import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Header = styled.header`
   user-select: none;
   height: ${({ theme }) => theme.sizes.siteHeaderHeight};
   background-color: ${({ theme }) => theme.brandColors.blue};
   position: relative;
   z-index: 1000;
`;

const FixedHeader = styled(Header)`
   position: fixed;
   width: 100%;
   box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.3);
`;

const SiteHeaderShell = ({ fixed = false, ...props }) =>
   fixed ? <FixedHeader {...props} /> : <Header {...props} />;

SiteHeaderShell.propTypes = {
   fixed: PropTypes.bool,
};

export { SiteHeaderShell };
